/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `pending` - Pending
 * * `accepted` - Accepted
 * * `declined` - Declined
 * @export
 */
export const BookingChangeStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Declined: 'declined'
} as const;
export type BookingChangeStatusEnum = typeof BookingChangeStatusEnum[keyof typeof BookingChangeStatusEnum];


export function instanceOfBookingChangeStatusEnum(value: any): boolean {
    for (const key in BookingChangeStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(BookingChangeStatusEnum, key)) {
            if (BookingChangeStatusEnum[key as keyof typeof BookingChangeStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingChangeStatusEnumFromJSON(json: any): BookingChangeStatusEnum {
    return BookingChangeStatusEnumFromJSONTyped(json, false);
}

export function BookingChangeStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingChangeStatusEnum {
    return json as BookingChangeStatusEnum;
}

export function BookingChangeStatusEnumToJSON(value?: BookingChangeStatusEnum | null): any {
    return value as any;
}

export function BookingChangeStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingChangeStatusEnum {
    return value as BookingChangeStatusEnum;
}
